import { apiClient } from '_app'
import { ApiResponse, VehicleTypeDto } from 'dtos'

export const getVehicleTypes = () =>
  apiClient.get<ApiResponse<VehicleTypeDto[]>>('/api/vehicle-types').then(response => response.data)
